export default {
  title: 'Detalhes do preço',
  subtotal: 'Subtotal',
  method_fee: 'Taxa de entrega',
  tip: 'Gorjeta',
  service_fee: 'Processamento online',
  payment_method_upcharge_fee: 'Taxa PayPal',
  discount: 'Desconto',
  taxes: 'Impostos',
  total: 'Total',
};
